// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationTimeseriesRecordingId } from './FermentationTimeseriesRecording';
import { fermentationAttributeDefinitionId } from './FermentationAttributeDefinition';
import { timeseriesSeriesId } from './TimeseriesSeries';
import { z } from 'zod';
export const fermentationRecordingSeries = z.object({
    recording_id: fermentationTimeseriesRecordingId,
    attribute_id: fermentationAttributeDefinitionId,
    series_id: timeseriesSeriesId,
});
export const fermentationRecordingSeriesInitializer = z.object({
    recording_id: fermentationTimeseriesRecordingId,
    attribute_id: fermentationAttributeDefinitionId,
    series_id: timeseriesSeriesId,
});
export const fermentationRecordingSeriesMutator = z.object({
    recording_id: fermentationTimeseriesRecordingId.optional(),
    attribute_id: fermentationAttributeDefinitionId.optional(),
    series_id: timeseriesSeriesId.optional(),
});
//# sourceMappingURL=FermentationRecordingSeries.js.map